quoteModule.controller('quoteCustomerCardController',
    ['$scope', 'quoteCreationEvents', 'rateQuoteCoordService',
    function ($scope, quoteCreationEvents, rateQuoteCoordService) {
        //customer information data model
        $scope.customerCard = rateQuoteCoordService.CustomerData;

        //When the Customer Data changes, we update the info on the customer card
        $scope.$on(quoteCreationEvents.customerDataChange, function() {
            $scope.customerCard = rateQuoteCoordService.CustomerData;
        });
    }]);